<div class="card fill-height">
  <div class="card-body pt-4 pt-lg-5">
    @if (!loading() && !failed()) {
      <h3 class="text-center mb-3 mb-lg-4">
        Successfully created your Paystashio account in {{ accountingProvider() }}
      </h3>
      <div class="row justify-content-center mb-4">
        <div class="col-auto">
          <div class="card shadow">
            <div class="card-body">
              <div class="card bg-pays-subtle-gray mb-3">
                <div class="card-body px-0 px-sm-3 d-flex justify-content-center">
                  <div class="row align-items-center gx-0 gx-md-2 my-0 my-lg-2 flex-nowrap">
                    <div class="col-auto">
                      <img
                        ngSrc="./assets/accounting-logos/contra-accounts/pays.svg"
                        width="90"
                        height="90"
                        alt="Paystashio" />
                    </div>
                    <div class="col-auto">
                      <picture>
                        <source
                          media="(min-width: 768px)"
                          srcset="./assets/accounting-logos/contra-accounts/connect-long.svg"
                          width="348"
                          height="30" />
                        <source
                          media="(min-width: 450px)"
                          srcset="./assets/accounting-logos/contra-accounts/connect.svg"
                          width="141"
                          height="41"
                          class="img-fluid" />
                        <img
                          ngSrc="./assets/accounting-logos/contra-accounts/connect.svg"
                          width="90"
                          height="26"
                          alt="Connected"
                          class="img-fluid" />
                      </picture>
                    </div>
                    <div class="col-auto">
                      @if (accountingProvider()) {
                        <img
                          [ngSrc]="providerImgUrl()"
                          width="89"
                          height="89"
                          [alt]="accountingProvider()" />
                      }
                    </div>
                  </div>
                </div>
              </div>
              <p class="fw-medium lead text-center">How your accounts will reflect in {{ accountingProvider() }}</p>
              <div class="row mb-3 row-cols-1 row-cols-sm-2 gy-3">
                <div class="col mh-100">
                  <div class="card bg-pays-subtle-gray h-100">
                    @if (contraAccounts().length > 0) {
                      <div class="card-body d-flex flex-column justify-content-between">
                        <p>
                          <span class="text-muted">Name:</span> <br />
                          <span class="fw-semibold">{{ contraAccounts()[0].name }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="text-muted">Description:</span> <br />
                          <span class="fw-semibold">{{ contraAccounts()[0].description }}</span>
                        </p>
                      </div>
                    } @else {
                      <app-loader></app-loader>
                    }
                  </div>
                </div>
                <div class="col mh-100">
                  <div class="card bg-pays-subtle-gray h-100">
                    @if (contraAccounts().length > 0) {
                      <div class="card-body d-flex flex-column justify-content-between">
                        <p>
                          <span class="text-muted">Name:</span> <br />
                          <span class="fw-semibold">{{ contraAccounts()[1].name }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="text-muted">Description:</span> <br />
                          <span class="fw-semibold">{{ contraAccounts()[1].description }}</span>
                        </p>
                      </div>
                    } @else {
                      <app-loader></app-loader>
                    }
                  </div>
                </div>
              </div>
              @if (sourceAccount()) {
                <div class="card mb-3 bg-pays-subtle-gray">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col">
                        <span class="text-muted">Linked bank account:</span> <br />
                        <span class="fw-semibold">{{ sourceAccount()?.name }}</span>
                      </div>
                      <div class="col-auto">
                        <i
                          class="iconoir-info-circle text-muted fs-3"
                          placement="left"
                          ngbTooltip="This bank account funds your Paystashio balance, ensuring your transfers reconcile seamlessly in {{
                            accountingProvider()
                          }}."></i>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <a
                routerLink="/accounting/categories"
                class="btn btn-primary d-block w-100">
                Manage Categories
              </a>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <h3 class="text-center mb-3 mb-lg-4">Loading accounts ...</h3>
      <app-loader class="my-5"></app-loader>
    }

    @if (failed()) {
      <div class="alert alert-danger">Failed to create contra accounts. Please try again.</div>
    }
  </div>
</div>
